"use strict";

var refreshMessage = document.getElementById("refresh-message");
var closeMsgBtn = document.querySelector("#refresh-message .close");
var signalRRetries = 0;
closeMsgBtn.addEventListener(
  "click",
  function () {
    refreshMessage.classList.remove("show");
  },
  false
);

var connection = new signalR.HubConnectionBuilder()
  .withUrl("//sock.larepublica.co/refresh")
  .build();

var startConnection = function () {
  signalRRetries++;
  if (signalRRetries < 6) {
    connection.start().catch(function (err) {
      setTimeout(function () {
        startConnection();
      }, 30000 + Math.random() * 30000);
    });
  }
};

connection.on("RefreshHome", function () {
  refreshMessage.classList.add("show");
});

connection.on("HomeElection", function (a, b) {
  if (vueElection2019) {
    vueElection2019.setHome(a);
    vueElection2019.setNewBulletin(b);
  }
});

connection.on("Election2019", function (a) {
  if (vueElection2019) {
    vueElection2019.setMinute(a);
  }
});

connection.onclose(function () {
  signalRRetries = 0;
  setTimeout(function () {
    startConnection();
  }, 3000 + Math.random() * 10000);
});

startConnection();
